import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LunaTable } from '../models/entity.model';
@Injectable()
export class EntityDefinitionService {

    constructor(public http: HttpClient) { }

    get(id: string): Observable<LunaTable> {
        return this.http.get<LunaTable>(`/api/entity/${id}`);
    }

    post(body: LunaTable): Observable<LunaTable> {
        return this.http.post<LunaTable>(`/api/entity/${body.id}`, body);
    }

    delete(id: string): Observable<LunaTable> {
        return this.http.delete<LunaTable>(`/api/entity/${id}`);
    }
}